import React, { useState, useEffect } from 'react';
import { Form, Formik } from 'formik';
import { Field } from "formik";
import { Elements } from '@stripe/react-stripe-js';
import { loadStripe } from '@stripe/stripe-js';
import { KEY } from 'web/components/utils/stripeKey';
import AddCard from './Credit-Card';
import Button from 'web/components/Button';
import ACHForm from 'web/components/ACHForm';
import RadioButton from "web/components/form-elements/RadioButton";
import CloseIcon from 'web/assets/images/CloseIcon.png';
import { Modal, ModalBody, ModalFooter } from 'reactstrap';
import AlertModal from 'web/components/AlertModal';
import './popup.scss';

export default ({ isOpen, toggle, type, title, props, pageData, getProfileResponse, individual, callBackModal, callBackFetchApi, content, link, onClickHander, paymentType, pageLanguageContents }) => {
  const stripePromise = loadStripe(KEY);
  const [modal, setModal] = useState(false);
  const [modalContent, setModalContent] = useState();
  const [modalLink, setModalLink] = useState();
  const toggleModal = () => setModal(!modal);

  const [acccontType, setAcccontType] = useState("");

  const [radioTypes, setRadioTypes] = useState([])

  // ach is enabled for all users, beta users restriction is lifted
  useEffect(() => {
    setRadioTypes([
      {
        value: "bankAccount",
        label: "ACH",
      },
      {
        value: "creditCard",
        label: "Card",
      }
    ])
    if (pageData?.buyerPaymentDetails?.cardDetails?.length > 0) setAcccontType('bankAccount')
    else setAcccontType('creditCard')
  }, [isOpen])

  const onChangeHandler = (e, props, setFieldValue) => {
    const { setTouched, validateForm, isValid } = props;
    validateForm();
    setTouched({});
    if (pageData?.buyerPaymentDetails?.cardDetails?.length > 0) {
      props.setFieldValue('accountType', e.target.value)
      setAcccontType(e.target.value);
    } else if (e.target.value !== 'creditCard') {
      props.setFieldValue('accountType', 'creditCard')
      setAcccontType('creditCard');
      setModalContent('Please add a card before adding ACH account.');
      toggleModal();
    } else {
      props.setFieldValue('accountType', 'creditCard')
      setAcccontType('creditCard');
    }
  };

  const getRegisterInitialValues = (obj) => {
    return {
      accountType: pageData?.buyerPaymentDetails?.cardDetails?.length > 0 ? 'bankAccount' : 'creditCard'
    }
  }

  return (
    <div className='alert-modal'>
      <Modal
        isOpen={isOpen}
        toggle={toggle}
        backdrop={'static'}
        centered={true}
        className='card-modal'>
        <div className='modal-content'>
          <div className='header'>
            <Button handleClick={() => {
              toggle(!isOpen)
            }}>
              <img src={CloseIcon} className="closeIcon" alt="close-icon" />
            </Button>
            <h3>{type === "ACH" ? "ACH/" : ""}Card Details</h3>
          </div>
          <ModalBody>
            <div>
              <h3 className='modal-title'>{title}</h3>
            </div>
            <div className='modal-content'>
              <h6 className='my-2 mb-4'>{content}</h6>

              {type === "ACH" ?
                <Formik
                  validateOnMount
                  enableReinitialize={true}
                  initialValues={getRegisterInitialValues()}
                  onSubmit={(values) => { }}
                >
                  {(props) => {
                    const { setFieldValue } = props;
                    return (
                      <Form className="form">
                        <div><div class="app-input-text"></div></div>
                        <div className="col-12 displayFlex">
                          <div>
                            {radioTypes &&
                              radioTypes.map((value, index) => (
                                <div key={index}>
                                  <Field
                                    component={RadioButton}
                                    name="accountType"
                                    className="radio-label"
                                    id={value.value}
                                    defaultValue={pageData?.buyerPaymentDetails?.cardDetails?.length > 0 ? radioTypes[0].value : radioTypes[1].value}
                                    onSelect={(e) => onChangeHandler(e, props, setFieldValue)}
                                    label={value.label}
                                    checked={value.value === acccontType}
                                  />
                                </div>
                              ))}
                          </div>
                        </div>
                        {acccontType === "bankAccount" &&
                          <Elements stripe={stripePromise}> <ACHForm props={props} callBackModal={callBackModal} callBackFetchApi={callBackFetchApi} /></Elements>}
                        {acccontType === "creditCard" && <AddCard type={type} individual={individual} callBackModal={callBackModal} callBackFetchApi={callBackFetchApi} callBack={() => {
                          onClickHander()
                        }} paymentType={paymentType} pageLanguageContents={pageLanguageContents} />}

                      </Form>
                    );
                  }}
                </Formik>
                :
                <AddCard type={type} individual={individual} callBackModal={callBackModal} callBackFetchApi={callBackFetchApi} callBack={() => {
                  onClickHander()
                }} paymentType={paymentType} pageLanguageContents={pageLanguageContents} />}

            </div>
          </ModalBody>
          <ModalFooter className='modal-footer'>
          </ModalFooter>
        </div>
        <AlertModal
          isOpen={modal}
          toggle={toggleModal}
          title=''
          alertType=''
          callBackAlert={() => { }}
          content={modalContent}
          link={modalLink}
        />
      </Modal>
    </div>
  );
};